const MINUTES_STEP = 15;
const toMinutes = (value = "") => {
  if (!value)
    return 0;
  const [hours, minutes] = String(value).split(":");
  return Number(hours) * 60 + Number(minutes ?? 0);
};
export {
  MINUTES_STEP,
  toMinutes
};
